import { FC } from 'react'
import { Box, SelectChangeEvent, Typography } from '@mui/material'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import SelectV2 from 'ui/components/form-components-v2/select-v2'
import { OnyxiaTooltip } from 'ui/components/tooltip'
import { StepFieldWrapper } from '../../jiraWizard.styles'
import { ContextVariant } from '../wizard.utils'

const LOCK_WARNING = 'This domain cannot be changed once the integration is saved.'

interface Props {
  variants: ContextVariant[]
  value: string
  disabled?: boolean
  onChange: (contextType: string) => void
}

/* Connector Domain step. Options are spec-driven from the connector's
 * onyxia_context variants; the choice is fixed once the integration is saved. */
const ConnectorDomainStep: FC<Props> = ({ variants, value, disabled, onChange }) => (
  <StepFieldWrapper>
    <Box className="field-label-row">
      <Typography className="field-label">Connector Domain</Typography>

      <OnyxiaTooltip title={LOCK_WARNING} placement="top">
        <Box component="span" className="field-warning">
          <ExclamationTriangleIcon width={16} height={16} />
        </Box>
      </OnyxiaTooltip>
    </Box>

    <SelectV2
      id="connector_domain"
      label=""
      placeholder="Select Connector Domain"
      value={value}
      options={variants.map((variant) => ({ label: variant.label, value: variant.value }))}
      disabled={disabled}
      onChange={(e: SelectChangeEvent<unknown>) => onChange(e.target.value as string)}
    />
  </StepFieldWrapper>
)

export default ConnectorDomainStep
